// DailyWeather.js
import React from "react";
import PropTypes from "prop-types";

function DailyWeather({ dateNum, dayIcon, tempHigh, tempLow }) {
  const dayOfWeek = new Date(dateNum * 1000).toLocaleDateString("en-US", {
    weekday: "long",
  });

  return (
    <div className="day">
      <h3>{dayOfWeek}</h3>
      <img className="weather-icon" src={dayIcon} alt="Weather icon" />
      <div className="temp-container">
        <div className="temp-high">High: {tempHigh}&deg;F</div>
        <div className="temp-low">Low: {tempLow}&deg;F</div>
      </div>
    </div>
  );
}

// Define prop types for DailyWeather
DailyWeather.propTypes = {
  dateNum: PropTypes.number.isRequired,
  dayIcon: PropTypes.string.isRequired,
  tempHigh: PropTypes.number.isRequired,
  tempLow: PropTypes.number.isRequired,
};

export default DailyWeather;
